import MarkdownIt from 'markdown-it'
import * as mila from 'markdown-it-link-attributes'
import * as mdTable from 'markdown-it-multimd-table'
import ReactHtmlParser from 'react-html-parser'

export const expectedDomains = [
  'freedomdebtrelief.com',
  'freedomfinancialnetwork.com',
  'freedomplus.com',
  'lendage.com',
  'consolplus.com',
  'www.achieve.com',
]

export const internalExpectedDomains = ['www.bills.com']

export const externalsRegex = new RegExp(
  `^(.*(${expectedDomains.join('|')}).*)|(tel.*)|(mailto.*)|(^/)|(^\\/[a-z0-9]+)$`
)

export const internalRegex = new RegExp(
  `^(.*(${internalExpectedDomains.join('|')}).*)|(tel.*)|(mailto.*)|(^/)|(^\\/[a-z0-9]+)$`
)

export function convertMarkdown(markdown) {
  const md = new MarkdownIt()

  md.use(mila, [
    {
      matcher(href) {
        return !externalsRegex.test(href) && !internalRegex.test(href)
      },
      attrs: {
        target: '_blank',
        rel: 'nofollow',
      },
    },
    {
      matcher(href) {
        return internalRegex.test(href)
      },
      attrs: {
        target: '_self',
        rel: 'follow',
      },
    },
    {
      matcher(href) {
        return externalsRegex.test(href)
      },
      attrs: {
        target: '_blank',
        rel: 'follow',
      },
    },
  ])

  const markdownTree = md.use(mdTable, {
    html: true,
    linkify: true,
    typographer: true,
    rowspan: true,
    headerless: true,
  })

  const allowedTags = new Map([
    ['&lt;br&gt;', '<br>'],
    ['&lt;br/&gt;', '<br>'],
    ['&lt;br &gt;', '<br>'],
    ['&lt;li&gt;', '<li>'],
    ['&lt;/li&gt;', '</li>'],
    ['&lt;ul&gt;', '<ul>'],
    ['&lt;/ul&gt;', '</ul>'],
    ['&lt;ol&gt;', '<ol>'],
    ['&lt;/ol&gt;', '</ol>'],
  ])
  const htmlTree = markdownTree
    .render(markdown)
    .replace(/(&lt;|&lt;\/)[a-z]+(&gt;| &gt;|\/&gt;)/gm, (matched) => {
      const matchedTag = allowedTags.get(matched)

      return matchedTag ?? ''
    })

  return ReactHtmlParser(htmlTree)
}
